<template>
  <compare-power-card class="bg-indigo-10 text-white">
    <compare-power-card-header>
      <q-icon name="savings"></q-icon>
      Save time and money on your other home services
    </compare-power-card-header>

    <q-card-section>
      <div class="text-150">
        Like we just did with electricity, we can help you compare and save when selecting your other home services.
      </div>
    </q-card-section>

    <!--    <q-card-section class="text-100">-->
    <!--      <div class="text-bold">Get settled even faster with these exclusive offers</div>-->
    <!--      <div>This is only available TODAY for ComparePower customers</div>-->
    <!--    </q-card-section>-->

    <q-card-section class="text-100 row">
      <q-item class="col-12 col-sm-6">
        <q-item-section avatar top>
          <q-icon name="check_circle" color="primary" size="sm"></q-icon>
        </q-item-section>
        <q-item-section>
          <div class="text-bold">Electric</div>
          Done!
        </q-item-section>
      </q-item>

      <q-item class="col-12 col-sm-6">
        <q-item-section avatar top>
          <q-icon name="circle" color="white" size="sm"></q-icon>
        </q-item-section>
        <q-item-section>
          <div class="text-bold">Internet/TV</div>
          Get connected and enjoy the best entertainment
        </q-item-section>
      </q-item>

      <q-item class="col-12 col-sm-6">
        <q-item-section avatar top>
          <q-icon name="circle" color="white" size="sm"></q-icon>
        </q-item-section>
        <q-item-section>
          <div class="text-bold">Home Security</div>
          Protection you can trust from top companies
        </q-item-section>
      </q-item>

      <q-item class="col-12 col-sm-6">
        <q-item-section avatar top>
          <q-icon name="circle" color="white" size="sm"></q-icon>
        </q-item-section>
        <q-item-section>
          <div class="text-bold">Home/Renter Insurance</div>
          Safeguard yourself and your belongings
        </q-item-section>
      </q-item>
    </q-card-section>

    <q-card-section class="text-100">
      <div class="row">
        <div class="col-12 col-md-5 text-center">
          <q-btn color="secondary" label="Compare options online now" no-caps class="rounded-borders-8"
                 padding="10px 30px" :href="ibex_url" target="_blank"></q-btn>
          <div class="q-mt-md text-center">
            <q-icon name="schedule"></q-icon>
            Available 24 / 7
          </div>
        </div>
        <div class="col-12 col-md-2 text-center">
          <div class="q-pa-md">
            or call
          </div>
        </div>
        <div class="col-12 col-md-5 text-center">
          <q-btn color="primary" label="Call (844) 901-1247" href="tel:1-844-901-1247" no-caps class="rounded-borders-8"
                 padding="10px 40px"></q-btn>
          <div class="q-mt-md">
            <q-icon name="person"></q-icon>
            Real human
          </div>
        </div>
      </div>
    </q-card-section>

  </compare-power-card>
</template>

<script>
import ComparePowerCard from "components/ComparePowerCard";
import ComparePowerCardHeader from "components/ComparePowerCardHeader";

export default {
  name: "OtherServices",
  components: { ComparePowerCardHeader, ComparePowerCard },
  setup() {
    const ibex_url = process.env.IBEX_URL;
    return {
      ibex_url
    }
  }
}
</script>

<style scoped>

</style>
